import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdministradoraDetalharComponent } from './administradora-detalhar.component';




@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: AdministradoraDetalharComponent }    
    ])],
    exports: [RouterModule]
})
export class AdministradoraDetalharRoutingModule { }
